export default __webpack_public_path__ + "static/media/payroll.181b521a.jpg";